/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { getCurrentUser } from '@nextcloud/auth'
import axios from '@nextcloud/axios'
import { confirmPassword } from '@nextcloud/password-confirmation'
import { generateOcsUrl } from '@nextcloud/router'
import { SCOPE_SUFFIX } from '../../constants/AccountPropertyConstants.ts'

/**
 * Save the primary account property value for the user
 *
 * @param {string} accountProperty the account property
 * @param {string|boolean} value the primary value
 * @return {object}
 */
export async function savePrimaryAccountProperty(accountProperty, value) {
	// TODO allow boolean values on backend route handler
	// Convert boolean to string for compatibility
	if (typeof value === 'boolean') {
		value = value ? '1' : '0'
	}

	const userId = getCurrentUser().uid
	const url = generateOcsUrl('cloud/users/{userId}', { userId })

	await confirmPassword()

	const res = await axios.put(url, {
		key: accountProperty,
		value,
	})

	return res.data
}

/**
 * Save the federation scope of the primary account property for the user
 *
 * @param {string} accountProperty the account property
 * @param {string} scope the federation scope
 * @return {object}
 */
export async function savePrimaryAccountPropertyScope(accountProperty, scope) {
	const userId = getCurrentUser().uid
	const url = generateOcsUrl('cloud/users/{userId}', { userId })

	await confirmPassword()

	const res = await axios.put(url, {
		key: `${accountProperty}${SCOPE_SUFFIX}`,
		value: scope,
	})

	return res.data
}
